import { aiServiceHttpClient } from "src/common/AIServiceHttpClient";
import {
  EditServiceData,
  SaveData,
  UserCreateList,
} from "src/models/aiPlatform";

export class AIPlatformServiceClient {
  //账户管理
  //获取所有用户列表
  async allUserList(name?: string, email?: string, phone?: string) {
    return await aiServiceHttpClient.get(
      "/admin/api/UserManageV2/AllUserList",
      {
        params: {
          name: name,
          email: email,
          phone: phone,
        },
      }
    );
  }

  //创建用户
  async addUser(data: UserCreateList) {
    return await aiServiceHttpClient.post(
      "/admin/api/UserManageV2/AddUser",
      data,
      {}
    );
  }

  //服务管理
  //获取服务列表
  async serviceList() {
    return await aiServiceHttpClient.get(
      "/admin/api/ServiceManage/AllServiceList"
    );
  }

  //新增服务
  async createService(payload: EditServiceData) {
    return await aiServiceHttpClient.post("/admin/api/ServiceManage", payload);
  }

  //修改服务
  async updateService(payload: EditServiceData) {
    return await aiServiceHttpClient.put("/admin/api/ServiceManage", payload);
  }

  //删除服务
  async deleteService(serviceId: number) {
    return await aiServiceHttpClient.delete(
      `/admin/api/ServiceManage/${serviceId}`
    );
  }

  //修改服务状态
  async changeStatus(serviceId: number) {
    return await aiServiceHttpClient.put(
      `/admin/api/ServiceManage/${serviceId}`
    );
  }

  //获取服务详情
  async getServiceDetail(serviceId: number) {
    return await aiServiceHttpClient.get(
      `/admin/api/ServiceManage/${serviceId}`
    );
  }

  //用户服务管理
  //获取用户列表
  async getAppServiceList(name?: string, email?: string, phone?: string) {
    return await aiServiceHttpClient.get("/admin/api/UserManageV2", {
      params: {
        name: name,
        email: email,
        phone: phone,
      },
    });
  }

  //获取平台服务列表
  async getServiceManage() {
    return await aiServiceHttpClient.get("/admin/api/ServiceManage");
  }

  //搜索用户
  async getUserListBySearch(searchStr?: string) {
    return await aiServiceHttpClient.get(
      "/admin/api/UserManageV2/UserListBySearch",
      {
        params: {
          searchStr: searchStr,
        },
      }
    );
  }

  //获取用户服务列表
  async getUserService(userId?: number) {
    return await aiServiceHttpClient.get(
      "/admin/api/UserManageV2/UserService",
      {
        params: {
          userId: userId,
        },
      }
    );
  }

  //保存数据
  async saveData(data: SaveData) {
    return await aiServiceHttpClient.post(
      "/admin/api/UserManageV2/SaveData",
      data,
      {}
    );
  }

  //更新数据
  async updateData(data: SaveData) {
    return await aiServiceHttpClient.post(
      "/admin/api/UserManageV2/UpdateData",
      data,
      {}
    );
  }

  //刷新密钥
  async refreshSecretKey(userId: number, secretKeyNumber: number) {
    return await aiServiceHttpClient.post(
      `/admin/api/UserManageV2/RefreshSecretKey?userId=${userId}&secretKeyNumber=${secretKeyNumber}`,
      {},
      {}
    );
  }
}
export const AiServiceClient = new AIPlatformServiceClient();
